import { CountBadge } from "@libs/zapi-ui/custom";
import { cva, type VariantProps } from "class-variance-authority";
import { ChevronDown } from "lucide-react";
import { ComponentProps, forwardRef } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

const filterChipButtonVariants = cva(
  "inline-flex h-8 min-h-8 items-center justify-center gap-1 whitespace-nowrap rounded-lg px-3 text-[14px] leading-5 font-medium text-innoveraZinc-950 outline-none ring-1 ring-inset transition-colors disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      state: {
        default:
          "bg-transparent ring-innoveraZinc-150 hover:ring-innoveraZinc-200 active:ring-innoveraZinc-200",
        active: "bg-innoveraZinc-100 ring-innoveraZinc-200",
        selected: "bg-transparent ring-innoveraZinc-900"
      }
    },
    defaultVariants: {
      state: "default"
    }
  }
);

export type TFilterChipButtonProps = ComponentProps<"button"> &
  VariantProps<typeof filterChipButtonVariants> & {
    count?: number;
    withCaret?: boolean;
  };

export const FilterChipButton = forwardRef<HTMLButtonElement, TFilterChipButtonProps>(function FilterChipButton(
  { state, count, withCaret, className, type, children, ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type={type || "button"}
      className={cn(filterChipButtonVariants({ state }), className)}
      {...props}
    >
      {children}
      {typeof count === "number" && count > 0 && <CountBadge>{count}</CountBadge>}
      {withCaret && <ChevronDown className="size-4 shrink-0" />}
    </button>
  );
});
